import * as yup from 'yup';

export const billingAddressInitialValues = {
  address1: '',
  address2: '',
  city: '',
  country: '',
  state: '',
  zip: '',
};

export const billingAddressValidation = yup.object().shape({
  address1: yup.string().required('Address 1 is required'),

  city: yup.string().required('City is required'),

  country: yup.string().required('Country is required'),

  state: yup.string().required('State is required'),

  zip: yup
    .string()
    .required('Zip is required')
    .matches(/^\d{5}$/, 'Must be 5 digits'),
});
